export default __webpack_public_path__ + "images/1c72115ae6e87f43e3f11ca43483b89d-reframe-judgements.svg";